import React from 'react';
import { Paper, Typography, Button, Stack } from '@mui/material';
import teamSuccessSvg from 'assets/team-success.svg';
import { Link as RouterLink } from 'react-router-dom';
import { RouteList } from 'types';
import { useCampaign } from 'hooks';

export const CampaignCreationSuccessPage = () => {
  const { getCampaignQuery } = useCampaign();

  return (
    <Paper sx={{ px: 5, py: 10 }}>
      <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <img src={teamSuccessSvg} alt="congratulations" />
        <Typography variant="h1" sx={{ mb: 4 }}>
          Glückwunsch!
        </Typography>
        <Typography variant="subtitle1" textAlign="center">
          Deine Kampagne <strong>{getCampaignQuery.data?.campaign?.name}</strong> wurde erfolgreich fertiggestellt.
        </Typography>

        <Typography variant="subtitle1" sx={{ lineHeight: '24px', mb: 10 }} textAlign="center">
          Weitere Infos und Links findest du in der Bestätigungs-E-Mail die du soeben erhalten hast.
        </Typography>
        <Button color="primary" variant="contained" component={RouterLink} to={RouteList.MyCampaigns}>
          zu meinen kampagnen
        </Button>
      </Stack>
    </Paper>
  );
};
